import { PieChart, Pie, Cell, ResponsiveContainer, Legend } from 'recharts';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { t } from 'i18next';

const colors = [
    '#1976d2',
    '#7fb4e8',
    '#b6cde8',
    '#607d8b',
    '#000000',
    '#be73da',
    '#9c27b0',
    '#51005e'
];

const TYPE_LABELS = {
    rehabilitation: 'Reabilitação',
    treadmill: 'Passadeira',
    ergometer: 'Bicicleta ergométrica',
    walking: 'Caminhada',
    running: 'Corrida',
    cycling: 'Ciclismo',
    rest: 'Descanso',
    other: 'Outro',
    unknown: 'Outro'
};

export default function ExerciseTypesPie({ exerciseTypes }) {
    const translatedData = (exerciseTypes || []).map((item) => ({
        ...item,
        name: TYPE_LABELS[item.name] || item.name
    }));

    return (
        <Card>
            <CardContent sx={{ backgroundColor: '#f9f9f9' }}>
                <Typography variant="h5" fontWeight={700} gutterBottom>
                    {t('exerciseStats.exerciseTypes')}
                </Typography>
                <Box
                    sx={{
                        height: 3,
                        width: 135,
                        backgroundColor: '#1976d2',
                        borderRadius: 2,
                        mb: 2
                    }}
                />
                <ResponsiveContainer width="100%" height={300}>
                    <PieChart>
                        <Pie
                            data={translatedData}
                            cx="50%"
                            cy="50%"
                            innerRadius={50}
                            outerRadius={70}
                            paddingAngle={3}
                            label
                            dataKey="value"
                            nameKey="name"
                        >
                            {translatedData.map((entry, index) => (
                                <Cell key={index} fill={colors[index % colors.length]} />
                            ))}
                        </Pie>
                        <text
                            x="50%"
                            y="43%"
                            textAnchor="middle"
                            fontSize="20"
                            fontWeight="bold"
                            fill="#1976d2"
                        >
                            {translatedData.reduce((sum, e) => sum + e.value, 0)}
                        </text>
                        <text
                            x="50%"
                            y="50%"
                            textAnchor="middle"
                            fontSize="14"
                            fontWeight="bold"
                        >
                            {t('exerciseStats.exercises')}
                        </text>
                        <Legend />
                    </PieChart>
                </ResponsiveContainer>
            </CardContent>
        </Card>
    );
}
